import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-part-requests-info-dialog',
  templateUrl: './part-requests-info-dialog.component.html',
  styleUrls: ['./part-requests-info-dialog.component.scss']
})
export class PartRequestInfoDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
